<template>
    <div>
        <ValidationObserver ref="formValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="semester" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox v-model="form.semester_id"
                                                 disabled
                                                 :validate-error="errors[0]"></semesters-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('teaching_staff')">
                        <ValidationProvider name="instructor_id" rules="required" v-slot="{ errors }">
                            <staff-auto-complete v-model="form.instructor_id"
                                                 :valueObject="instructorValueObject"
                                                 disabled
                                                 :validate-error="errors[0]" />
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('course')">
                        <div class="label-as-input font-weight-bold" v-if="course">
                            {{ course.code }} - {{ getLocaleText(course, 'name') }}
                        </div>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="from_date" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('start_date')">
                            <b-form-input type="datetime-local" size="sm" v-model="form.from_date" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>

                <b-col cols="12" md="6">
                    <ValidationProvider name="to_date" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('end_date')">
                            <b-form-input type="datetime-local" size="sm" v-model="form.to_date" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="content" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('content')">
                            <ck-editor v-model="form.content"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="section_ids" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('section')">
                            <multi-selectbox v-model="form.section_ids"
                                             :options="sectionOptions"
                                             :multiple="true"
                                             :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>
        <b-button variant="primary" @click="save">{{ $t('save').toUpper() }}</b-button>
    </div>
</template>
<script>

import LmsAnnouncementsService from "@/services/LmsAnnouncementsService"
import SectionService from "@/services/SectionService"
import moment from "moment/moment"
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue"
import CkEditor from "@/components/interactive-fields/Ckeditor.vue"

export default {
    components: {
        MultiSelectbox,
        CkEditor
    },
    props: {
        semesterId: {
            type: String,
            default: null
        },
        course: {
            type: Object
        },
        userData: {
            type: Object
        }
    },
    data() {
        return {
            form: {
                section_ids: []
            },
            instructorValueObject: {},
            sectionOptions: []
        }
    },

    created() {
        this.form.course_id = this.course.id
        this.form.semester_id = this.semesterId
        this.instructorValueObject = {
            value: this.userData.id,
            text: this.userData.full_name
        }
        this.form.instructor_id = this.userData.id
        this.getSections()
    },

    methods: {
        getSections() {
            this.sectionOptions = []
            const config = {
                params: {
                    course_id: this.course.id,
                    semester_id: this.semesterId
                },
            }
            SectionService.instructorSections(config).then(response => {
                if (response.data && response.data.data) {
                    response.data.data.forEach(item => {
                        this.sectionOptions.push({
                            value: item.section_id,
                            text: item.section
                        })
                    })
                    this.sectionOptions.sort((a, b) => a.text - b.text)
                }
            }).catch(e => {
                console.error(e)
            })
        },
        async save() {
            const isValid = await this.$refs.formValidate.validate();
            if (isValid){
                const formData = new FormData()
                const toDate = moment(this.form.to_date).format('YYYY-MM-DD HH:mm:ss')
                const fromDate = moment(this.form.from_date).format('YYYY-MM-DD HH:mm:ss')

                formData.append('content', this.form.content)
                formData.append('semester_id', this.semesterId)
                formData.append('course_id', this.form.course_id)
                formData.append('title', this.form.title || '')
                formData.append('instructor_id', this.form.instructor_id)
                formData.append('from_date', fromDate)
                formData.append('to_date', toDate)

                if (this.form.file && this.form.file.length) {
                    formData.append('file', this.form.file[0])
                }

                if (Array.isArray(this.form.section_ids)) {
                    this.form.section_ids.forEach(id => {
                        formData.append('section_ids[]', id)
                    })
                } else if (this.form.section_ids) {
                    formData.append('section_ids[]', this.form.section_ids)
                }

                LmsAnnouncementsService.store(formData)
                    .then(response => {
                        this.$toast.success(response.data.message)
                        this.$emit('announcementSuccess', true)
                    }).catch(err => {
                    this.showErrors(err)
                })
            }
        }
    },

};
</script>
